@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-breadcrumb {
    min-height: 3.75em;
    display: inline-flex;
    align-items: center;
    column-gap: var(--column-gap);
    color: var(--color);
    padding-right: 1em;
    overflow: clip;
  
    // ==== Breadcrumb Trail Container
  
    .trail-container {
      display: flex;
      align-items: center;
      column-gap: var(--column-gap);
    }
  
    // ==== Context Menu
  
    .context-menu-container {
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: var(--column-gap);
    }
  
    .context-menu-icon {
      transform: rotate(90deg);
    }
  
    // ==== Container for Link + Icon
  
    .link-container {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      column-gap: var(--column-gap);
    }
  
    // ==== Chevron Icon (between "trail" links)
  
    .separator-icon {
      vertical-align: middle;
    }
  
    // ==== Link & Current Page
  
    .breadcrumb-link,
    .current-page {
      white-space: nowrap;
      overflow: visible;
    }
  }
}
